import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { SharedModule } from '../../shared/shared.module';
import { UsersService } from '../user/service/users.service';
import { SurveyFormSubmissionComponent } from './components/survey-form-submission/survey-form-submission.component';
import { SurveyManagementService } from './service/survey-management.service';
import { SurveyManagementRoutingModule } from './survey-management-routing.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    InputsModule,
    SurveyManagementRoutingModule
  ],
  providers: [UsersService, SurveyManagementService],
  declarations: [SurveyFormSubmissionComponent],
  exports: [SurveyFormSubmissionComponent],
  entryComponents: [SurveyFormSubmissionComponent]
})
export class SurveyManagementModule {}
